//#region package.json
var version = "1.6.12";
//#endregion
export { version };
